import React from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  onClick?: () => void;
}
export function FadeIn({
  children,
  className = '',
  delay = 0,
  onClick
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: 'easeOut'
  }} className={className} onClick={onClick} data-id="element-147">
      {children}
    </motion.div>;
}